import gql from 'graphql-tag';

export const GOOGLE_API_ACCOUNT_QUERY = gql`
  query GoogleApiAccountQuery {
    googleApiAccounts {
      accounts {
        googleAccountId
        googleAccountName
        timeZone
      }
      errors
    }
  }
`;
